import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import { AuthProvider } from "./contexts/AuthContext";
import { CurrencyProvider } from "./contexts/CurrencyContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import NotFound from "pages/NotFound";

import MainDashboard from "./pages/main-dashboard";
import Login from "./pages/login";
import SubscriptionPricing from "./pages/subscription-pricing";
import Register from "./pages/register";
import AnalysisResults from "./pages/analysis-results";
import PropertyPlanning from "./pages/property-planning";
import MortgageCalculator from "./pages/mortgage-calculator";
import Settings from "./pages/settings";
import PropertyDossier from "./pages/property-dossier";
import InvestorProfile from "./pages/investor-profile";
import PurchaseJourney from "./pages/purchase-journey";
import LandingPage from "./pages/landing";
import DemoSignup from "./pages/demo-signup";
import DemoResults from "./pages/demo-results";
import Gp3rDemo from "./pages/gp3r-demo";
import SharedAnalysis from "./pages/shared-analysis";
import PropertyAnalysisWizard from "./pages/property-analysis-wizard";
import PortfolioProjectionPage from "./pages/portfolio-projection";
import InvestmentPlanning from "./pages/investment-planning";
import PlanningLandingPage from "./pages/planning-landing";

// V2 Flow-First Pages (maquettes - gardées pour référence)
import LandingPageV2 from "./pages/v2/landing";
import DemoPageV2 from "./pages/v2/demo";
import AnalysePageV2 from "./pages/v2/analyse";
import AchatPageV2 from "./pages/v2/achat";

// Pages légales
import Privacy from "./pages/privacy";
import Terms from "./pages/terms";
import Legal from "./pages/legal";
import Contact from "./pages/contact";

// Guards
import LandingGate from "./LandingGate";
import AuthCallback from "./pages/auth-callback";

const Routes = () => {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <CurrencyProvider>
            <ErrorBoundary>
              <ScrollToTop />
              <RouterRoutes>
                {/* Landing & Public routes */}
                <Route
                  path="/"
                  element={
                    <LandingGate>
                      <LandingPage />
                    </LandingGate>
                  }
                />

                <Route path="/login" element={<Login />} />
                <Route path="/auth/callback" element={<AuthCallback />} />
                <Route path="/register" element={<Register />} />
                <Route path="/gp3r-demo" element={<Gp3rDemo />} />
                <Route path="/demo-signup" element={<DemoSignup />} />
                <Route path="/demo-results" element={<DemoResults />} />
                <Route path="/shared" element={<SharedAnalysis />} />

                {/* App routes */}
                <Route path="/main-dashboard" element={<MainDashboard />} />
                <Route path="/subscription-pricing" element={<SubscriptionPricing />} />
                <Route path="/investor-profile" element={<InvestorProfile />} />
                <Route path="/analysis-results" element={<AnalysisResults />} />

              
                <Route path="/property-analysis-wizard" element={<PropertyAnalysisWizard />} />

                <Route path="/portfolio-projection" element={<PortfolioProjectionPage />} />
                <Route path="/investment-planning" element={<InvestmentPlanning />} />
                <Route path="/planification" element={<PlanningLandingPage />} />

                <Route path="/purchase-journey" element={<PurchaseJourney />} />
                <Route path="/property-planning" element={<PropertyPlanning />} />
                <Route path="/mortgage-calculator" element={<MortgageCalculator />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/property-dossier" element={<PropertyDossier />} />

                {/* V2 Flow-First Routes (maquettes) */}
                <Route path="/v2" element={<LandingPageV2 />} />
                <Route path="/v2/demo" element={<DemoPageV2 />} />
                <Route path="/v2/analyse" element={<AnalysePageV2 />} />
                <Route path="/v2/achat" element={<AchatPageV2 />} />

                {/* Pages terms et conditions */}
                <Route path="/terms" element={<Terms />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/legal" element={<Legal />} />
                <Route path="/contact" element={<Contact />} />

                <Route path="*" element={<NotFound />} />
              </RouterRoutes>
            </ErrorBoundary>
          </CurrencyProvider>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
};

export default Routes;
